module.exports = __webpack_public_path__ + "media/images/pages/supporting_partners/supporting_partners-99e42304e8a1dc11e2a658fb872de3c7.png";